<template>
    <Head title="Contact" />

    <transition
        appear
        mode="out-in"
        enter-from-class="transform -translate-x-4 opacity-0"
        enter-to-class="transform translate-x-0 opacity-100"
        leave-from-class="transform translate-x-0 opacity-100"
        leave-to-class="transform translate-x-4 opacity-0"
        enter-active-class="transition duration-150"
        leave-active-class="transition duration-100"
    >
        <div class="relative mx-auto mt-12 max-w-7xl">
            <div
                class="px-4 py-16 sm:px-6 lg:col-span-2 lg:px-8 lg:py-24 xl:pr-12"
            >
                <div class="max-w-2xl mx-auto">
                    <h2
                        class="text-3xl font-extrabold tracking-tight text-gray-900 dark:text-gray-100"
                    >
                        Do you have a question ?
                    </h2>
                    <p class="mt-9 text-2xl">Want to get your CDL jobs listed on our website ?</p>
                    <p
                        class="mt-9 flex space-x-3 text-lg leading-6 text-gray-500 dark:text-gray-400"
                    >
                        <span>Let us know here</span>
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke-width="1.5"
                            stroke="currentColor"
                            class="w-6 h-6"
                        >
                            <path
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                d="M21.75 6.75v10.5a2.25 2.25 0 01-2.25 2.25h-15a2.25 2.25 0 01-2.25-2.25V6.75m19.5 0A2.25 2.25 0 0019.5 4.5h-15a2.25 2.25 0 00-2.25 2.25m19.5 0v.243a2.25 2.25 0 01-1.07 1.916l-7.5 4.615a2.25 2.25 0 01-2.36 0L3.32 8.91a2.25 2.25 0 01-1.07-1.916V6.75"
                            />
                        </svg>

                        <a
                            href="mailto: info@opencdljobs.com"
                            class="text-blue-500"
                            >info@opencdljobs.com</a
                        >
                    </p>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
// import { useReCaptcha } from "vue-recaptcha-v3";
import { Head, useForm, usePage, Link } from "@inertiajs/inertia-vue3";
import { computed } from "vue";

export default {
    setup() {
        // const { executeRecaptcha, recaptchaLoaded } = useReCaptcha();
        const form = useForm({
            name: "",
            email: "",
            phone_number: "",
            message: "",
            "g-recaptcha-response": "",
        });
        const route = window.route;

        const success = computed(() => usePage().props.value.flash.success);

        const submit = async () => {
            //   await recaptchaLoaded();

            //   form["g-recaptcha-response"] = await executeRecaptcha("contact");

            form.post(route("contact"));
        };

        return {
            form,
            submit,
            success,
            route: window.route,
        };
    },

    components: {
        Head,
        Link,
    },
};
</script>
